import { useState, useEffect, useLayoutEffect } from "react";
import LogoFull from "../assets/img/Logofull.svg";
import privacy_tip from "../assets/img/privacy_tip.svg";
import success from "../assets/img/success.svg";
import error from "../assets/img/error.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import whiteLogo from "../assets/img/whiteLogo.svg";
import MobClose from "../assets/img/close_white.svg";
// import Subscriptions from "./Subscriptions";
import Accounts from "./Accounts";
import { userLogout } from "../libs/auth";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import {
  resetMigratedUser,
  updateResendOtp,
  updatedPhone,
  verifyUpdatedOtp,
} from "../redux/slices/authSlice";
import { getUser, getUserToken, setUser } from "../libs/user";
import { useForm } from "react-hook-form";
import OTPInput from "react-otp-input";
import CloseIcon from "../assets/img/svgs/CloseIcon";
import { phoneValidation } from "../utils/validation";
import RemittanceHome from "./Remittance/RemittanceHome";
import { formatUsNumber } from "../libs/utils";

function ManageAccounts() {
  const authToken = getUserToken();

  const [searchParams] = useSearchParams();

  const userObj = useSelector((state) => state.auth?.updatePhoneService);

  const [isUsermigrated, setuserMigrated] = useState("");

  const [account, setaccount] = useState(0);
  const [openPOpup, setPopup] = useState(false);
  const [isErrmsg, setErrmsg] = useState(false);
  const auth = useSelector((state) => state.auth);
  const [userHasPhone, setUserHasPhone] = useState("");

  const addBankFromNB = searchParams.get("type");

  const migrateType = searchParams.get("migrateType");

  const NUMBER = /^[0-9]*$/;

  const {
    formState: { errors },
  } = useForm();

  const [bodyHeight, setBodyHeight] = useState();
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [otpErr, setOtpErr] = useState("");
  const [otp, setOtp] = useState("");
  const [screenType, setScreenType] = useState(1);
  const [sendOTPSuccess, setSendOTPSuccess] = useState(false);
  const [verifyOtpsuccess, setVerifyOtpsuccess] = useState("");
  const [errOnPopup, seterrorOnPopup] = useState(false);

  const [counter, setCounter] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRef = useRef();
  const [mailUpdated, setMailUpdated] = useState("");
  // useEffect(() => {
  //   if (auth.user.data?.token) {
  //     //Get bank accounts
  //     //Get bank accounts End
  //   }
  // }, []);
  const fetchUserData = async () => {
    const storedUserData = await getUser();
    const mailUpdated = storedUserData?.user?.email_updated;
    setMailUpdated(mailUpdated);
  };

  useEffect(() => {
    fetchUserData();
    if (authToken) {
      if (!mailUpdated && mailUpdated !== "") {
        navigate("/signup", { replace: true });
      }
    }
  }, [authToken, mailUpdated]);

  const showSubscriptionPage = () => {
    // this.accountsPage= false;
    // this.subscriptionPage = true;
    document.getElementById("accounts").classList.remove("active");
    document.getElementById("subscriptions").classList.add("active");
    setaccount(1);
  };
  const showAccountsPage = () => {
    // this.accountsPage= true;
    // this.subscriptionPage = false;
    document.getElementById("showSendMoneySection").classList.remove("active");
    document.getElementById("accounts").classList.add("active");
    setaccount(1);
  };

  const showSendMoneySection = () => {
    document.getElementById("accounts").classList.remove("active");
    document.getElementById("showSendMoneySection").classList.add("active");
    setaccount(0);
  };

  useLayoutEffect(() => {
    const headerHeight = $(".header").outerHeight();
    const footerHeight = $(".footer").outerHeight();
    setBodyHeight(
      parseFloat($(window).outerHeight() || 0) -
        (parseFloat(headerHeight || 0) + parseFloat(footerHeight || 0))
    );
  }, []);

  useEffect(() => {
    if (addBankFromNB === "addBankFromNB") {
      setaccount(1);
    }
  }, [addBankFromNB]);

  useEffect(() => {
    if (migrateType === "phone") {
      setPopup(true);
    }
  }, [migrateType]);

  const validatePhone = () => {
    const formattedPhone = phoneValidation(phone);
    if (formattedPhone) {
      setPhone(formattedPhone);
      setPhoneError(false);
      return true;
    } else {
      setPhoneError("Please enter valid number");
      return false;
    }
  };

  const handleUpdate = () => {
    setPopup(true);
  };

  const handleContinue = () => {
    if (validatePhone()) {
      const input = ("+1" + phone).replace(/[- )(]/g, "");
      dispatch(
        updatedPhone({
          mobile_number: input,
          token: authToken,
        })
      )
        .unwrap()
        .then((response) => {
          setScreenType(2);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const isValidForm = () => {
    if (!otp || otp.length !== 6) {
      return false;
    }
    return true;
  };
  const handleKeyUp = (e) => {
    if (otp.length === 6) {
      e?.target?.blur();
      handleVerifyOtp();
    }
  };

  useEffect(() => {
    (async function () {
      try {
        const storedUserData = await getUser();
        const migrated = storedUserData?.user?.user_migrated;
        if (migrated === false) {
          const formattedNo = formatUsNumber(
            storedUserData?.user?.mobile_number
          );
          setuserMigrated(storedUserData?.user?.user_migrated);
          setPhone(formattedNo);
          setUserHasPhone(formattedNo);
        }
      } catch (e) {
        console.error(e);
      }
    })();
    // if (user_Data?.getProfileService?.data) {
    //   const formattedNo = formatUsNumber(
    //     user_Data?.getProfileService?.data?.user?.mobile_number
    //   );
    //   setuserMigrated(user_Data?.getProfileService?.data?.user?.user_migrated);
    //   setPhone(formattedNo);
    //   setUserHasPhone(formattedNo);
    // }
  }, []);

  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setOtp(value);
    }
  };
  const handleResendOTP = () => {
    const input = ("+1" + phone).replace(/[- )(]/g, "");
    dispatch(
      updateResendOtp({
        mobile_number: input,
        message_id: userObj?.data?.message_id,
        token: authToken,
      })
    )
      .unwrap()
      .then((response) => {
        setSendOTPSuccess(true);
      })
      .catch((error) => {
        setSendOTPSuccess(false);
        console.log(error);
      });
  };

  const handleVerifyOtp = () => {
    if (isValidForm()) {
      const formattedPhone = ("+1" + phone).replace(/[- )(]/g, "");
      seterrorOnPopup(false);
      dispatch(
        verifyUpdatedOtp({
          otp,
          mobile_number: formattedPhone,
          message_id: userObj?.data?.message_id,
          verify_otp_type: "UPDATE_MOBILE",
          token: authToken,
        })
      )
        .unwrap()
        .then(async (response) => {
          const userData = await getUser();
          setVerifyOtpsuccess(true);
          if (isUsermigrated === false) {
            dispatch(resetMigratedUser());
            setUser({
              ...userData,
              user: { ...userData?.user, user_migrated: true },
            });
          }
          setuserMigrated(true);
          setScreenType(3);
          // navigate("/accounts", { replace: true });
        })
        .catch((error) => {
          setVerifyOtpsuccess(false);
          if (error?.error?.code === 5017) {
            setOtpErr(error?.error?.message);
          } else {
            setScreenType(4);
          }
        });
    }
  };

  const closePopup = () => {
    if (auth.updatedVerifyOtp?.error || auth.updateResendOtpService?.error) {
      seterrorOnPopup(true);
    }

    setPopup(false);
    setScreenType(1);
    setSendOTPSuccess(false);
    // setPhone("");
    setOtp("");
  };
  useEffect(() => {
    if (!phone) {
      setScreenType(1);
    }
  }, []);

  useEffect(() => {
    if (sendOTPSuccess) {
      setCounter(60);
    }
  }, [sendOTPSuccess]);

  useEffect(() => {
    if (screenType === 2) setCounter(60);
  }, [screenType]);

  useEffect(() => {
    if (screenType === 2) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [screenType, counter]);

  const handleChange = (e) => {
    let { value } = e.target;
    let tempVal = "";
    const formattedPhone = value.replace(/[- )(]/g, "").substring(0, 10);

    const first = formattedPhone.substring(0, 3);
    const middle = formattedPhone.substring(3, 6);
    const last = formattedPhone.substring(6, 10);
    if (formattedPhone.length > 6) {
      tempVal = `(${first}) ${middle}-${last}`;
    } else if (formattedPhone.length > 3) {
      tempVal = `(${first}) ${middle}`;
    } else if (formattedPhone.length > 0) {
      tempVal = `(${first}`;
    }
    setPhone(tempVal);
    setPhoneError(false);
  };

  const handleUserMigration = () => {
    setPopup(true);
  };

  return (
    <div>
      <div className="subscrb-header">
        <div className="container-xl">
          <a href="/" className="hedMobLogo">
            <img src={LogoFull} />
          </a>
          {isUsermigrated === false && (
            <>
              <div class="updateContainer">
                <img src={privacy_tip} alt="privacy" />
                <div class="textContainer">
                  <span className="upgradeText">
                    Security Upgrade. Please update your login credentials
                    before April 30th.
                  </span>
                  <span className="updateText" onClick={handleUpdate}>
                    Update Now -{">"}{" "}
                  </span>
                </div>
              </div>
            </>
          )}
          <div className="rgtBtnSec">
            <div className="rgt-btns">
              {/* <a class="btns btn-link logout-btn" (click)="logOut()">Log Out</a> */}
              <a
                onClick={() => userLogout()}
                className="btns btn-link logout-btn"
              >
                Log Out
              </a>
            </div>
            {/* <button type="button" class="btns btn-border logout-btn" (click)="logOut()">Log Out</button> */}
            {/* <button type="button" class="btns btn-border login-btn">Log In</button>
                             <button type="button" class="btns btnSecondry-new mobHide">Sign Up</button> */}
            <label className="burger-menu desktopHide">
              <span />
              <span />
              <span />
            </label>
          </div>
          <nav className="mobMenu">
            <div className="mob_loader">
              <div className="mobMenuInner">
                <div className="mobMenuHead">
                  <Link to="/" className="mobMenuLogo">
                    <img src={whiteLogo} />
                  </Link>
                  <button type="button" className="mobClsBtn">
                    <img src={MobClose} />
                  </button>
                </div>
                <ul className="mobMenuList">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="how-it-works">How it Works</a>
                  </li>
                  {/* <li><a href="#!">Help</a></li> */}
                </ul>
                <div className="appStoreSec">
                  <button
                    type="button"
                    onClick={() => {}}
                    className="appStoreBtn"
                  />
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <div className="content-sec" style={{ minHeight: `${bodyHeight}px` }}>
        <div className="container-xl">
          <div className="subs-tabs">
            <div className="subs-tabs-link-col">
              <div className="nav">
                <a
                  className="nav-links active"
                  id="showSendMoneySection"
                  onClick={showSendMoneySection}
                >
                  Send Money
                </a>
                <a
                  className="nav-links"
                  id="accounts"
                  onClick={showAccountsPage}
                >
                  Accounts
                </a>
                {/* <a
                  className="nav-links"
                  id="subscriptions"
                  onClick={showSubscriptionPage}
                >
                  Subscriptions
                </a> */}
              </div>
            </div>
            <div className="subs-tab-content">
              {account === 0 && (
                <RemittanceHome
                  isLoggedIn={true}
                  handleUserMigration={handleUserMigration}
                />
              )}
              {account === 1 && <Accounts />}
            </div>
            {/* <div class="subs-tab-content">
                <div class="subs-hed">
                    <h2>Accounts</h2>
                    <p>Manage your linked bank and cards.</p>
                </div>
                    <div class="subscribe-card">
                        <button type="button" class="subscrib-inner subscrib-btn">
                                <div class="subscrib-img">
                                    <img src="../assets/img/link-bank-icon.svg" class="border-round">
                                </div>
                                <div class="subscrib-info">
                                    <h3 class="title-txt">Link a Bank</h3>
                                </div>
                        </button>
                        </div>                                 
              </div> */}
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="container-xl">
          <div className="footerLinkSec susctiotns-footer">
            <p className="subsc-footer-link">
              {" "}
              About Abound Subscriptions &amp; Privacy{" "}
              <a href="/privacy" target="_blank" className="subsc-footer-link">
                <span className="link-icon-arrow" />
              </a>
            </p>
          </div>
        </div>
      </div>
      {openPOpup && (
        <>
          <div className="popUpOverlay">
            <div className="popUpInner">
              <div
                className={
                  screenType === 1
                    ? auth.updatePhoneService.error
                      ? `popUpBox errInputBox noBorder`
                      : `popUpBox inputBox noBorder`
                    : screenType === 2
                    ? auth.updatedVerifyOtp?.error
                      ? ` popUpBox errotpBox noBorder`
                      : `popUpBox otpBox noBorder`
                    : ` popUpBox successBox noBorder`
                }
              >
                {(screenType === 3 || screenType === 4) && (
                  <div onClick={closePopup} className="closeIcon">
                    <div className="iconLogo">
                      <CloseIcon color="#f9da87" height={20} width={20} />
                    </div>
                  </div>
                )}
                {screenType === 3 && (
                  <div className="successLogo">
                    <img src={success} alt="success" />
                  </div>
                )}
                {screenType === 4 && (
                  <div className="successLogo">
                    <img src={error} alt="error" />
                  </div>
                )}
                <div className="popupTxtContainer">
                  <div className="headerContainer">
                    {screenType === 1 && <h3>Enter Phone Number</h3>}
                    {screenType === 2 && <h3>Verify your Phone</h3>}

                    {(screenType === 1 || screenType === 2) && (
                      <div onClick={closePopup} className="closeIcon">
                        <div
                          className={isErrmsg ? `iconStyle` : `iconContainer`}
                        >
                          <CloseIcon color="#f9da87" height={20} width={20} />
                        </div>
                      </div>
                    )}
                  </div>

                  {screenType === 1 && (
                    <>
                      <div
                        className={
                          auth.updatePhoneService.error || phoneError
                            ? `descprContainer`
                            : `descprTextContainer`
                        }
                      >
                        <p className="descprText">
                          We are upgrading our systems to make our app & your
                          data more secure.
                        </p>
                        <p className="descprText">
                          {/* {userHasPhone
                            ? `Please use your registered phone no +1 ${formatUsNumber(
                                userHasPhone
                              )} in order to login on Times Club app.`
                            : `Please enter/verify your phone number to upgrade your
                            login credentials. Next time, you can directly login
                            by phone number.`} */}
                          Please enter/verify your phone number to upgrade your
                          login credentials. Next time, you can directly login
                          by phone number.
                        </p>
                      </div>
                    </>
                  )}
                  {screenType === 2 && (
                    <div className="otpTxt">
                      <p>
                        We sent a 6 digit code to +1 {phone}. Please enter it
                        below.
                      </p>
                    </div>
                  )}
                  {screenType === 3 && verifyOtpsuccess && (
                    <div>
                      <h3>Success!</h3>
                      <div className="successText">
                        <span>
                          Your login credentials have been updated. Next time,
                          you can directly login by phone number.
                        </span>
                      </div>
                    </div>
                  )}
                  {screenType === 4 && !verifyOtpsuccess && (
                    <div>
                      <h3>Error!</h3>
                      <div className="successText">
                        <span>
                          Your login credentials could not be updated. Please
                          try again.
                        </span>
                      </div>
                    </div>
                  )}
                  {screenType === 2 && (
                    <div onKeyUp={handleKeyUp} className={`otpInput`}>
                      <OTPInput
                        shouldAutoFocus={true}
                        numInputs={6}
                        value={otp}
                        onChange={handleOtpChange}
                        inputStyle={`otpinput_style`}
                        className={`formGroupOtp`}
                        renderInput={(props) => (
                          <input {...props} type="number" inputMode="numeric" />
                        )}
                      />

                      {auth.updatedVerifyOtp?.error?.error?.message &&
                        !auth.updateResendOtpService?.error &&
                        !errOnPopup && (
                          <div className={`errorBox`}>
                            {auth.updatedVerifyOtp?.error?.error?.message}
                          </div>
                        )}
                      {/* <span className="errMsg otp">{otpErr}</span> */}
                      {auth.updateResendOtpService?.error &&
                        !errors.otp &&
                        !errOnPopup && (
                          <div
                            className={
                              sendOTPSuccess ? `resendOTPtext` : `errorBox`
                            }
                          >
                            {auth.updateResendOtpService?.error?.error?.message}
                          </div>
                        )}
                      {sendOTPSuccess && !errOnPopup && (
                        <div className={`resendOTPtext`}>
                          {auth.updateResendOtpService?.data?.message}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {screenType === 2 && (
                  <>
                    {auth.updateResendOtpService?.error?.error?.code ===
                    5029 ? (
                      ""
                    ) : (
                      <>
                        {counter !== 0 ? (
                          <div className="otpInputText">{`Resend code in ${counter}s`}</div>
                        ) : (
                          <div
                            className={`resendOtp`}
                            onClick={handleResendOTP}
                          >
                            {" "}
                            {"Send Code Again ->"}
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
                {screenType === 1 && (
                  <>
                    {!phone && phoneError && (
                      <div className="errorBox">
                        <p>Field cannot be blank.</p>
                      </div>
                    )}
                    {phone && phoneError && (
                      <>
                        <div className="errorBox">
                          <p>{phoneError}</p>
                        </div>
                      </>
                    )}
                    {/* {auth.mobileLoginService.error && phone && !phoneError && (
                      <div className="errorBox">
                        <p>{auth.mobileLoginService.error.message}</p>
                      </div>
                    )} */}
                    {auth.updatePhoneService.error && phone && !phoneError && (
                      <div className="errorBox">
                        <p>{auth.updatePhoneService.error.error.message}</p>
                      </div>
                    )}
                  </>
                )}
                {screenType === 1 && (
                  <>
                    <div
                      className={
                        phoneError ||
                        auth.mobileLoginService?.error ||
                        auth.updatePhoneService?.error
                          ? `popupBtnSec inputField`
                          : `popupBtnSec inputContainer`
                      }
                    >
                      <span className="countryCode">+1</span>
                      <input
                        className="phoneInput"
                        placeholder="Phone Number"
                        value={phone}
                        onChange={handleChange}
                        maxLength={14}
                        required={true}
                        disabled={!!userHasPhone}
                      />
                    </div>
                    <span className="numberText">
                      Please use your personal mobile number.
                    </span>

                    <div className="popupBtnSec">
                      <button
                        type="submit"
                        style={{ padding: "10px 61px", width: "320px" }}
                        className="btn btn-primary continueBtn"
                        onClick={handleContinue}
                      >
                        Continue
                      </button>
                    </div>
                    <div className="privacyContainer">
                      <span className="numberText">
                        By hitting Continue, you agree to our Consent, Terms,
                        Privacy Policy.
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
export default ManageAccounts;
